<template>
    <div>
        <vs-row  class="form">
            <vs-col class="mb-3">
                <h5>Agregar cuenta</h5>
                <h6 class="mt-3">Las cuentas que se añadan en este apartado son utilizadas para la domiciliación de los pagos.</h6>
            </vs-col>
            <vs-col sm="12" lg="6" class="mt-2">
            <div>
                <label class="Tarjetahabiente" for="tarjetahabiente">Nombre de tarjetahabiente</label>
                <input type="text" name="name" id="tarjetahabiente" v-model="tarjetahabiente" placeholder="Nombre del tarjetahabiente" autocomplete="off">
            </div>
            </vs-col>
            <vs-col sm="12" lg="6" class="mt-2">
            <label class="Tarjetahabiente" for="banco">Banco</label>
            <select class="selectOption" v-model="banco" id="banco">
                <option value="" disabled selected>Seleccione un banco</option>
                <option v-for="option in bancoNombre" :key="option.id" :label="option.nombre" :value="option.id">{{option.nombre}}</option>
            </select>
            </vs-col>
            <vs-col sm="12" lg="6" class="mt-2">
            <label class="Tarjetahabiente" for="cuenta">Tipo de cuenta</label>
            <select class="selectOption" v-model="tipo" id="cuenta">
                <option value="" disabled selected>Seleccione tipo de cuenta</option>
                <option v-for="option in tipoNombre" :key="option.id" :label="option.nombre" :value="option.id">{{option.nombre}}</option>
            </select>
            </vs-col>
            <vs-col sm="12" lg="6" class="mt-2">
            <div>
                <label class="Tarjetahabiente" for="cuenta">No. de Cuenta</label>
                <input type="number" min="5" max="16" name="number" id="cuenta" v-model="cuenta" placeholder="No. de Cuenta">
            </div>
            </vs-col>
            <vs-col sm="12" lg="6" class="ml-auto mt-3 d-flex" style="justify-content: flex-end">
            <vs-button
                square
                @click="postGuardarCuenta()"
            >
                Guardar
            </vs-button>
            </vs-col>
        </vs-row>
        <vs-row class="mt-4">
                <vs-col class="mb-0">
                    <h5>Cuentas disponibles</h5>
                </vs-col>
            <vs-table striped>
                    <template #thead>
                    <vs-tr>
                        <vs-th style="text-align: left">
                            Tarjetahabiente
                        </vs-th>
                        <vs-th>
                            Banco
                        </vs-th>
                        <vs-th>
                            Tipo de cuenta
                        </vs-th>
                        <vs-th>
                            Cuenta
                        </vs-th>
                        <vs-th>
                        </vs-th>
                    </vs-tr>
                    </template>
                    <template #tbody>
                    <vs-tr
                        :key="i"
                        v-for="(tr, i) in cuentaGuardada"
                        :data="tr"
                    >
                        <vs-td>
                        {{ tr.tarjetahabiente }}
                        </vs-td>
                        <vs-td>
                        {{ tr.banco }}
                        </vs-td>
                        <vs-td>
                        {{ tr.tipo }}
                        </vs-td>
                        <vs-td>
                        {{ tr.cuenta }}
                        </vs-td>
                        <vs-td>
                            <vs-button
                                circle
                                icon
                                danger
                                flat
                                @click="abrirEliminar(tr)"
                            >
                                <i class="fas fa-times" style="font-size: 12px;"></i>
                            </vs-button>
                        </vs-td>
                    </vs-tr>
                    </template>
                    <template #notFound>
                        No hay cuentas agregadas
                    </template>
                </vs-table>
        </vs-row>
        <vs-dialog width="550px" not-center v-model="activeEliminada">
            <template #header>
            <h4 class="not-margin">
                ¿Esta seguro de eliminar la cuenta?
        
            </h4>
            </template>


            <div class="con-content">
                <p>
                    Tarjetahabiente: <strong>{{cuentaEliminada.tarjetahabiente}}</strong>
                </p>
                <p>
                    Banco: <strong>{{cuentaEliminada.banco}}</strong>
                </p>
                <p>
                    Tipo de cuenta: <strong>{{cuentaEliminada.tipo}}</strong>
                </p>
                <p>
                    No. de cuenta: <strong>{{cuentaEliminada.cuenta}}</strong>
                </p>
            </div>

            <template #footer>
            <div class="con-footer">
                <vs-row>
                    <vs-col lg="6">
                        <vs-button style="width: 95%" @click="getEliminarCuenta(cuentaEliminada)" success>
                        De acuerdo
                        </vs-button>
                    </vs-col>
                    <vs-col lg="6">
                        <vs-button style="width: 95%" @click="activeEliminada=false" danger>
                        Cancelar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </div>
            </template>
        </vs-dialog>

    </div>
</template>

<script>
import domicializacion from '../../../../api/requests/domicializacion'
export default {
    props: [
        'personaId'
    ],
    data(){
        return{
            activeEliminada: false,
            addOther: false,
            tarjetahabiente: '',
            banco: '',
            tipo: '',
            cuenta: '',
            bancoNombre: [],
            tipoNombre: [],
            cuentaGuardada: [],
            cuentaEliminada: {},
        }
    },
    created(){
        this.getBancos()
        this.getCuenta()
        this.getCuentaGuardad()
    },
    methods: {
        async getBancos() {
            try {
                const response = await domicializacion.getBancos()
                this.bancoNombre = response.data
            } catch (error) {

            }
        },
        abrirEliminar(tr){
            const vm = this
            vm.cuentaEliminada = tr
            vm.activeEliminada = true 
        },
        async getCuenta() {
            try {
                const response = await domicializacion.getCuenta()
                this.tipoNombre = response.data
            } catch (error) {

            }
        },
        async postGuardarCuenta() {
            try {
                const loading = this.$vs.loading()
                let formData = new FormData();
                formData.append("nombre_tarjetahabiente", this.tarjetahabiente),
                formData.append("banco", this.banco),
                formData.append("tipo_cuenta", this.tipo),
                formData.append("cuenta", this.cuenta)
                const response = await domicializacion.getGuardarCuenta(this.personaId, formData)
                loading.close()
                this.tarjetahabiente = '',
                this.banco = '',
                this.tipo = '',
                this.cuenta = ''
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    title: 'Cuenta agregada',
                    text: 'La cuenta se agrego con éxito'
                })
                this.getCuentaGuardad()

            } catch (error) {

            }
        },
        async getCuentaGuardad() {
            try {
                const response = await domicializacion.getCuentaGuardad(this.personaId)
                this.cuentaGuardada = response.data.cuentas_bancarias
            } catch (error) {

            }
        },
        async getEliminarCuenta(cuenta) {
            try {
                console.log(cuenta.domiciliacion)
                if(cuenta.domiciliacion === false){
                    this.activeEliminada = false
                    const loading = this.$vs.loading()
                    const response = await domicializacion.getEliminarCuenta(cuenta.id)
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        title: 'Cuenta eliminada',
                        text: 'La cuenta se elimino con éxito'
                    })
                    this.getCuentaGuardad()
                }else {
                    this.activeEliminada = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        title: 'No se puede eliminar',
                        text: 'La cuenta no se puede eliminar debido a que esta asociada a un cargo.'
                    })
                }
            } catch (error) {
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    title: 'Algo salio mal',
                    text: 'Favor de contactar al administrador'
                })
            }
        },


    },
}
</script>

<style>
    .form .selectOption, input[type="text"], input[type="number"]{
        width: 95%;
        padding: 0.375rem 0.75rem;
        height: calc(1.6em + 0.75rem + 2px);
        font-size: 0.9rem;
        color: #495057;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
    }
    .form select:focus {
        outline: none;
        border-color: #2c3e50;
        box-shadow: 0 0 5px rgba(44, 151, 222, 0.2);
    }

    .form input[type="submit"] {
        border: none;
        background: #448aff;
        border-radius: 0.25em;
        padding: 5px 10px;
        color: #ffffff;
        font-weight: bold;
        float: right;
        cursor: pointer;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        appearance: none;
    }

    .addOther {
        border: none;
        background: #27AE60;
        border-radius: 0.25em;
        padding: 0;
        color: #ffffff !important;
        font-weight: bold;
        float: right;
        cursor: pointer;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        appearance: none;
        }

        .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>